// TODO(HUM-902): Make this a real feature flag:
// In the meantime, this is a convenient way to toggle the feature for testing
export const FEATURE_ENABLE_STEP_INDICATORS = false;

export const UPLOADED_FILES_DIR_NAME = `uploadedfiles`;

/**
 * Paths that do not require user authentication or household loading.
 * These are checked through middleware and in the HouseholdLoader provider.
 * Matching is prefix-based: a path in this list also matches any subpath beneath it.
 */
export const PUBLIC_PATHS = [
  '/health',
  '/login',
  '/no-permission',
  '/security-policy',
  '/frequently-asked-questions',
  '/waitlist-attestation',
  '/locale-selection',
  '/survey',
] as const;
